export default "__VITE_ASSET__Ban8LF4B__"